import React from 'react';
import WorkspaceSelector from '../../WorkspaceSelector/WorkspaceSelector';

const MobileHeader = () => {
  return (
    <div className="sticky top-0 left-0 right-0 bg-gray-800 shadow-lg z-50">
      <WorkspaceSelector variant="mobile" />
    </div>
  );
};

export default MobileHeader;




